import React from 'react';
import { Phone, ExternalLink } from 'lucide-react';
import { college } from '../mock/data';

export default function TopBar() {
  return (
    <div className="w-full bg-[#0B2E6E] text-white text-[13px]">
      <div className="container-x flex flex-col md:flex-row items-center justify-between gap-2 py-2">
        <div className="flex items-center gap-4 flex-wrap justify-center md:justify-start">
          <a href={`tel:${college.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:text-blue-200 transition-colors">
            <Phone size={14} />
            <span>{college.phone}</span>
          </a>
          <span className="opacity-80 hidden sm:inline">{college.approvals}</span>
        </div>
        <div className="flex items-center gap-5">
          <a href="#admissions" className="hover:text-blue-200 transition-colors">Apply Online</a>
          <span className="opacity-40">|</span>
          <a href="#contact" className="hover:text-blue-200 transition-colors flex items-center gap-1">
            Enquiry <ExternalLink size={12} />
          </a>
        </div>
      </div>
    </div>
  );
}
